export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="3" y="3" width="6" height="6" rx="1" stroke="#A87511" stroke-width="1.4" />
	</svg>
);
